import React, { memo } from "react";

const Retencion = () => {
  return <div>Retencion</div>;
};

export default memo(Retencion);
